import type { ReactNode } from 'react';
import { HiInformationCircle, HiCheckCircle, HiExclamationTriangle, HiXCircle } from 'react-icons/hi2';
import { BannerRoot, BannerGlyph, BannerBody, BannerTitle, type BannerIntent } from './StatusBanner.styled';

interface StatusBannerProps {
  intent?: BannerIntent;
  title?: string;
  children?: ReactNode;
}

const glyphFor = (intent: BannerIntent) => {
  switch (intent) {
    case 'success': return <HiCheckCircle />;
    case 'warning': return <HiExclamationTriangle />;
    case 'danger': return <HiXCircle />;
    case 'info':
    default: return <HiInformationCircle />;
  }
};

export function StatusBanner({ intent = 'info', title, children }: StatusBannerProps) {
  return (
    <BannerRoot $intent={intent} role={intent === 'danger' ? 'alert' : 'status'}>
      <BannerGlyph $intent={intent} aria-hidden>{glyphFor(intent)}</BannerGlyph>
      <BannerBody>
        {title ? <BannerTitle>{title}</BannerTitle> : null}
        {children}
      </BannerBody>
    </BannerRoot>
  );
}
